module.exports = __webpack_public_path__ + "img/conny-f-stage4-sulking.2bc0f523.png";